import { ReactNode } from 'react';

type Variant = 'default' | 'green' | 'amber' | 'red' | 'slate' | 'primary' | 'dark';
type Size = 'sm' | 'md';

export function Chip({
  children,
  variant = 'default',
  size = 'sm',
}: {
  children: ReactNode;
  variant?: Variant;
  size?: Size;
}) {
  const variants: Record<Variant, string> = {
    default: 'bg-slate-100 text-slate-700 border-slate-200',
    green: 'bg-primary-bg text-primary border-primary/20',
    amber: 'bg-[#fcf1e2] text-[#b8741e] border-[#b8741e]/25',
    red: 'bg-danger-bg text-danger border-danger/25',
    slate: 'bg-slate-100 text-slate-600 border-slate-300',
    primary: 'bg-primary-bg text-primary border-primary/20',
    dark: 'bg-slate-900 text-white border-slate-900',
  };
  const sizes: Record<Size, string> = {
    sm: 'text-[11px] px-2 py-0.5',
    md: 'text-xs px-2.5 py-1',
  };
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-medium tracking-tight ${variants[variant]} ${sizes[size]}`}
    >
      {children}
    </span>
  );
}
